import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-foreground-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-foreground-50">
              星空传媒
            </Link>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed">
              用影像传递温度，打造高品质影视内容。旗下实力派演员香菱作品全集，为粉丝提供一站式观影指南。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              作品分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(1).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              快速链接
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  全部作品
                </Link>
              </li>
              <li>
                <Link to="/category/latest" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  最新发布
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-200 mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-all"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
            <p className="mt-4 text-xs text-foreground-500">
              联系邮箱：contact@xingkong-media.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 星空传媒 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}